export enum FeedExportFormEnum {
    EmailsForExport = 'emailsForExport',
    CompaniesSelectorUid = 'companiesSelectorUid',
    FileFormat = 'fileFormat',
}

export enum ExportFileFormatEnum {
    Csv = 'csv',
    Xlsx = 'xlsx',
}
